<div class="flex flex-col bg-slate-50 rounded shadow">
    <!-- Predefined -->
    <div class="flex flex-row gap-1 items-center p-2">
        <div>Load:</div>
        <select #predefinedSelect (change)="onPredefinedSelected(predefinedSelect.value)" class="p-[5px] rounded-sm shadow-sm bg-white w-[20ch]">
            <option [attr.value]="undefined">None</option>
            @if (predefinedTasks) {
                @for (predefinedTask of predefinedTasks ; track predefinedTask.definitionName) {
                    <option [attr.value]="predefinedTask.definitionName">{{ predefinedTask.definitionName }}</option>
                }
            }
        </select>
        <div class="grow"></div>
        <div>Save As:</div>
        <input #predefinedSaveAsNameInput class="p-[5px] rounded-sm shadow-sm bg-white w-[20ch]">
        <button (click)="onSaveClicked()" class="p-1 rounded-sm shadow-sm w-[10ch] bg-white border border-opacity-0 border-ponder-link hover:border-opacity-100 hover:text-ponder-link disabled:text-slate-400 disabled:hover:border-opacity-0" [disabled]="isSavingPredefined || !predefinedSaveAsNameInput.value || predefinedSaveAsNameInput.value.length < 3">Save</button>
    </div>
    <!-- JSON -->
    <div class="flex flex-col p-2 pt-0">
        <textarea #propertiesTextArea class="bg-white rounded shadow-sm min-h-40 p-2 font-mono text-xs text-slate-600" spellcheck="false">{{taskParametersJson}}</textarea>
    </div>
    <!-- Run -->
    <div class="flex flex-row gap-1 p-2 bg-slate-100 rounded-b items-center border-t">
        <div>Timeout (seconds):</div>
        <input #timeoutSecondsInput type="number" min="30" max="7200" step="1" value="{{ timeoutSeconds }}" class="p-[5px] rounded-sm shadow-sm bg-white w-[10ch]">
        <div class="grow"></div>
        <button (click)="onRunClicked()" class="p-1 rounded-sm shadow-sm w-[10ch] bg-white border border-opacity-0 border-ponder-link hover:border-opacity-100 hover:text-ponder-link disabled:text-slate-400 disabled:hover:border-opacity-0" [disabled]="isRunningTask">
            Run
        </button>
    </div>
</div>
<ng-template #confirmationModalTemplate></ng-template>